const formatNumber = (num) => {
  num = parseInt(num);
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
}

export default formatNumber;